export default class ApiCall {
    public METHOD_POST: string = "POST";
    public METHOD_GET: string = "GET";

    public STATUS_ERROR = "ERROR";
    public STATUS_OK = "OK";

    private url: string;
    private headers = {};
    private params = {};
    private method: string;

    constructor(url: string, params = {}, headers = {}, method: string = "POST") {
        this.url = url;

        //console.log(params);
        this.params = params;
        this.headers = headers;
        this.method = method;
    }

    // /**
    //  *
    //  */
    // public async makeCall() {
    //     let url = this.getUrl();
    //     let headers = await this.getHeaders();
    //     let init = {
    //         method: this.getMethod(),
    //         headers: headers,
    //     };
    //
    //     //pokud mame parametry, tak je dle request metody pridame
    //     if (Object.keys(this.params).length) {
    //
    //         if (init.method === this.METHOD_POST) {
    //             // @ts-ignore
    //             init.body = JSON.stringify(this.params);
    //         } else {
    //             let paramsAsString = new URLSearchParams(this.params).toString();
    //             if (url.indexOf("?") > -1) {
    //                 url += "&" + paramsAsString;
    //             } else {
    //                 url += "?" + paramsAsString;
    //             }
    //         }
    //     }
    //     // console.log("call", url);
    //     // console.log("init", init);
    //     //TODO
    //     try {
    //         let response = await fetch(url, init);
    //         //
    //         // response.text().then((res) => {
    //         //   console.log("makecall response", res);
    //         // });
    //
    //         //let res = response.text();
    //         //console.log('call response text', res);
    //         let res = response.json();
    //         return res;
    //     } catch (e) {
    //         //console.log("error in api-call: ", e);
    //         return;
    //     }
    //
    //     //console.log("res", res);
    //     // return res;
    // }
    public async makeCall() {
        let url = this.getUrl();

        // Get and encode headers
        let headers: Record<string, string> = (await this.getHeaders()) || {};
        headers["Content-Type"] = "application/json";
        // for (const key in headers) {
        //     headers[key] = encodeURIComponent(headers[key]);
        // }

        let init: RequestInit = {
            method: this.getMethod(),
            headers: headers,
            credentials: 'include'
        };

        // Encode parameters
        if (Object.keys(this.params).length) {
            if (init.method === this.METHOD_POST) {
                const encodedParams = Object.fromEntries(
                    Object.entries(this.params).map(([key, value]) => [key, encodeURIComponent(String(value))])
                );
                init.body = JSON.stringify(encodedParams);
            } else {
                const encodedParams = new URLSearchParams();
                for (const [key, value] of Object.entries(this.params)) {
                    encodedParams.append(key, encodeURIComponent(String(value)));
                }
                url += (url.includes("?") ? "&" : "?") + encodedParams.toString();
            }
        }

        try {
            const response = await fetch(url, init);

            if (!response.ok) {
                const errorMessage = `HTTP error! status: ${response.status}`;
                console.error(errorMessage);
                return {
                    status: 'ERROR',
                    errors: [errorMessage],
                };
            }

            const res = await response.json();
            return res;
        } catch (error) {
            console.error("Error in makeCall:", error);

            if (error instanceof Error) {
                return {
                    status: 'ERROR',
                    errors: [error.message],
                };
            }

            return {
                status: 'ERROR',
                errors: ["Unknown error occurred"],
            };
        }
    }
    /**
     *
     */
    public getUrl(): string {
        return this.url;
    }

    /**
     *
     */
    public async getHeaders(): Promise<{}> {
        return this.headers;
    }

    /**
     *
     */
    public getMethod(): string {
        return this.method;
    }
}
